@import "../../global/normalize.css";

:host {
  --border-bottom-color: var(--ic-architectural-300);
  --splitter-color: var(--ic-architectural-100);

  display: flex;
  max-width: 100%;
}

:host(.ic-horizontal-scroll-light) {
  --splitter-color: var(--ic-color-keyline-lighten);
}

:host(.ic-horizontal-scroll-light) ic-button > svg {
  color: var(--ic-color-text-action-monochrome-dark);
}

:host(.ic-horizontal-scroll-dark) {
  --splitter-color: var(--ic-color-keyline-darken);
}

:host(.ic-horizontal-scroll-dark) ic-button > svg {
  color: var(--ic-color-text-action-monochrome-light);
}

/* Slotted items container element */
::slotted(*) {
  overflow-x: scroll;
  overflow-y: hidden;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin: calc(var(--ic-space-xs) * -1) !important;
  padding: var(--ic-space-xs) !important;
}

:host(.ic-horizontal-scroll-visible) ::slotted(*) {
  margin: calc(var(--ic-space-xs) * -1) 0 !important;
  padding: var(--ic-space-xs) !important;
}

.tabs-container::-webkit-scrollbar {
  display: none;
}

.scroll-container-left,
.scroll-container-right {
  display: flex;
}

.scroll-container-left {
  margin-left: var(--ic-space-xxs);
}

.scroll-container-right {
  margin-right: var(--ic-space-xxs);
}

.hidden {
  display: none;
}

.scroll-arrow {
  margin: var(--ic-space-xxs) 0;
}

.disabled .ic-tooltip-container {
  display: none !important;
}

.scroll-splitter-left,
.scroll-splitter-right {
  display: flex;
  height: var(--ic-space-lg);
  width: var(--ic-space-1px);
  margin-top: var(--ic-space-xs);
  border-radius: var(--ic-space-1px);
  background-color: var(--splitter-color);
}

.scroll-splitter-left {
  margin-left: calc(var(--ic-space-xxs) - var(--ic-space-1px));
}

.scroll-splitter-right {
  margin-right: calc(var(--ic-space-xxs) - var(--ic-space-1px));
}

.disabled .scroll-splitter-left,
.disabled .scroll-splitter-right {
  background-color: transparent;
}

:host(.ic-horizontal-scroll-dark) .disabled ic-button > svg,
:host(.ic-horizontal-scroll-light) .disabled ic-button > svg {
  color: var(--splitter-color) !important;
}

@media (prefers-reduced-motion: reduce) {
  ::slotted(*) {
    scroll-behavior: auto;
  }
}
